import { Dialog } from "./Dialog";
import { ModalChoice } from "@/lib/tour/steps/v2/modal";

function BulletPoint() {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 10C5.49213 10 6.71678 8.9367 7.8268 7.82681C8.93692 6.71582 10 5.49163 10 4.99945C10 4.50727 8.93692 3.28308 7.8268 2.17279C6.71578 1.063 5.49112 0 5 0C4.50787 0 3.28322 1.063 2.1732 2.17279C1.06318 3.28298 0 4.50717 0 4.99945C0 5.49163 1.06308 6.71582 2.1732 7.82611C3.28332 8.936 4.50797 10 5 10Z"
        fill="url(#paint0_linear_4643_1059)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4643_1059"
          x1="8.72298"
          y1="2.76468"
          x2="1.27548"
          y2="7.22319"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B5EDCB" />
          <stop offset="0.927083" stopColor="#A5B7FD" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function UnlockIcon() {
  return (
    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 7C5.25 4.1005 7.60051 1.75 10.5 1.75C12.6542 1.75 14.5034 3.0473 15.3128 4.89967C15.5063 5.3425 15.3041 5.85833 14.8613 6.05181C14.4185 6.24529 13.9026 6.04315 13.7092 5.60033C13.1683 4.36236 11.9339 3.5 10.5 3.5C8.567 3.5 7 5.067 7 7V7.87642C7.208 7.87499 7.4291 7.875 7.66386 7.875H13.3361C14.0405 7.87499 14.6218 7.87498 15.0953 7.91367C15.5872 7.95385 16.0393 8.0401 16.464 8.25648C17.1225 8.59203 17.658 9.12747 17.9935 9.78603C18.2099 10.2107 18.2961 10.6628 18.3363 11.1547C18.375 11.6282 18.375 12.2095 18.375 12.9138V14.2112C18.375 14.9155 18.375 15.4968 18.3363 15.9703C18.2961 16.4622 18.2099 16.9143 17.9935 17.339C17.658 17.9975 17.1225 18.533 16.464 18.8685C16.0393 19.0849 15.5872 19.1711 15.0953 19.2113C14.6218 19.25 14.0405 19.25 13.3362 19.25H7.66384C6.9595 19.25 6.37819 19.25 5.90465 19.2113C5.41282 19.1711 4.9607 19.0849 4.53603 18.8685C3.87747 18.533 3.34203 17.9975 3.00648 17.339C2.7901 16.9143 2.70385 16.4622 2.66367 15.9703C2.62498 15.4968 2.62499 14.9155 2.625 14.2111V12.9139C2.62499 12.2095 2.62498 11.6282 2.66367 11.1547C2.70385 10.6628 2.7901 10.2107 3.00648 9.78603C3.34203 9.12747 3.87747 8.59203 4.53603 8.25648C4.76537 8.13962 5.00272 8.06072 5.25 8.00653V7ZM6.04716 9.65786C5.66355 9.6892 5.46737 9.74601 5.33052 9.81574C5.00123 9.98352 4.73352 10.2512 4.56574 10.5805C4.49601 10.7174 4.4392 10.9135 4.40786 11.2972C4.37568 11.691 4.375 12.2005 4.375 12.95V14.175C4.375 14.9245 4.37568 15.434 4.40786 15.8278C4.4392 16.2115 4.49601 16.4076 4.56574 16.5445C4.73352 16.8738 5.00123 17.1415 5.33052 17.3093C5.46737 17.379 5.66355 17.4358 6.04716 17.4671C6.44099 17.4993 6.95049 17.5 7.7 17.5H13.3C14.0495 17.5 14.559 17.4993 14.9528 17.4671C15.3365 17.4358 15.5326 17.379 15.6695 17.3093C15.9988 17.1415 16.2665 16.8738 16.4343 16.5445C16.504 16.4076 16.5608 16.2115 16.5921 15.8278C16.6243 15.434 16.625 14.9245 16.625 14.175V12.95C16.625 12.2005 16.6243 11.691 16.5921 11.2972C16.5608 10.9135 16.504 10.7174 16.4343 10.5805C16.2665 10.2512 15.9988 9.98352 15.6695 9.81574C15.5326 9.74601 15.3365 9.6892 14.9528 9.65786C14.559 9.62568 14.0495 9.625 13.3 9.625H7.7C6.95049 9.625 6.44099 9.62568 6.04716 9.65786ZM10.5 11.8125C10.9833 11.8125 11.375 12.2043 11.375 12.6875V14.4375C11.375 14.9207 10.9833 15.3125 10.5 15.3125C10.0168 15.3125 9.625 14.9207 9.625 14.4375V12.6875C9.625 12.2043 10.0168 11.8125 10.5 11.8125Z"
        fill="white"
      />
    </svg>
  );
}

interface TheyDoModalProps {
  choices: ModalChoice[];
  onSelect: (id: string) => void;
}

export function TheyDoModalV2({ choices, onSelect }: TheyDoModalProps) {
  return (
    <>
      <Dialog
        isOpen
        onOpenChange={(e) => {}}
        style={{
          width: "540px",
          background: "linear-gradient(239deg, #B5EDCB 0%, #A5B7FD 92.71%)",
          borderRadius: "0.5rem",
          border: "0px solid rgba(0,0,0,0)",
          boxShadow:
            "0px 11.800000190734863px 12.399999618530273px -3px rgba(199, 210, 254, 0.24), 0px 1.7999999523162842px 1.899999976158142px -1px rgba(199, 210, 254, 0.29), 0px 0.699999988079071px 0.699999988079071px 0px rgba(199, 210, 254, 0.32), 0px 4.699999809265137px 4.900000095367432px -2px rgba(199, 210, 254, 0.27)",
        }}
      >
        <div
          style={{
            display: "flex",
            background: "linear-gradient(239deg, #E7F9EE 0%, #E2E7FE 100%)",
            borderRadius: "0.4rem",
            padding: "24px 24px",
            color: "rgba(28, 23, 23, 1)",
            position: "relative",
            overflow: "hidden",
          }}
        >
          <div>
            <div>
              <h2 style={{ margin: "0 0 8px 0", fontWeight: 700, fontSize: 14, lineHeight: "21px" }}>
                UNLOCK FULL ACCESS <br />
                for 14 days, no credit card required
              </h2>
            </div>
            <div style={{ color: "rgba(28, 23, 23, 1)", fontWeight: 500, fontSize: 12 }}>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                  <BulletPoint />
                  <span>Unlimited Journey AI generations</span>
                </div>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                  <BulletPoint />
                  <span>More users, journeys and journey boards</span>
                </div>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                  <BulletPoint />
                  <span>Integrations with Qualtrics and Jira</span>
                </div>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                  <BulletPoint />
                  <span>Custom tags and statuses</span>
                </div>
                <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                  <BulletPoint />
                  <span>Opportunity prioritization matrix</span>
                </div>
                <div>and more!</div>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "flex-end",
              alignItems: "flex-start",
            }}
          >
            <div
              style={{
                display: "flex",
                gap: "8px",
              }}
            >
              <button
                className="pyne-dialog__confirm-btn pyne-theydo-ghost-btn"
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  cursor: "pointer",
                  padding: "10px 14px 10px 12px",
                  height: "auto",
                  color: "rgba(86, 80, 77, 1)",
                  border: "none",
                }}
                onClick={() => {
                  const choice = choices.find((c) => c.id === "notNow");
                  onSelect(choice?.id || "");
                }}
              >
                Not now
              </button>
              <button
                className="pyne-dialog__confirm-btn"
                onClick={() => {
                  const choice = choices.find((c) => c.id === "unlock");
                  onSelect(choice?.id || "");
                }}
                style={{
                  fontSize: 14,
                  fontWeight: 500,
                  cursor: "pointer",
                  padding: "10px 14px 10px 12px",
                  height: "auto",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div style={{ marginRight: 8, display: "flex", alignItems: "center" }}>
                  <UnlockIcon />
                </div>
                <div>Unlock</div>
              </button>
            </div>
          </div>
          <div style={{ position: "absolute", bottom: -38, right: -35, width: 267 }}>
            <img
              src="https://base.pyne.ai/storage/v1/object/public/images/theydo-logos.png"
              alt="Logos"
              style={{ width: "100%" }}
            />
          </div>
        </div>
        {/* <button onClick={() => setIsOpen(false)}>Cancel</button> */}
      </Dialog>
    </>
  );
}
